import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { CommentsGrid, ReviewUpload, AdminAppIdHeader } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import { ActionButton } from 'fw/components';
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import UploadsConfig from './UploadsConfig/UploadsConfig';
import { QueueType } from 'areas/shared/consts';

class Articles extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: '',
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    updatePostData = (form, dirty) => {
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form });

        if (dirty === true)
            FormManager.dirt(this._form);

        this.handleDirt();
    }

    validateReviewStatus = (form) => {
        const me = this;
        let canComplete=
            (
                this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
            ) ||
            this.state.form.reviewUploads.every((reviewUpload) => { 
                return (me.getDocumentsConfig() && me.getDocumentsConfig()[reviewUpload.upload.uploadKey] && me.getDocumentsConfig()[reviewUpload.upload.uploadKey].visible) ? reviewUpload.validDocument : true; 
            });

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getArticlesInfo'),
            save: API.Admin.url('/certification/saveArticlesInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            entityId: this.state.form.savedEntityId,
            rowVersion: this.state.form.rowVersion,

            reviewUploads: this.state.form.reviewUploads,
            reviewStatus: this.state.form.reviewStatus,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            reviewComment: this.state.reviewComment
        }
    }

    handleReviewUpload = (formUpload) => {
        let form = this.state.form;
        var items = form.reviewUploads;

        var foundIndex = items.findIndex(x => x.upload.uploadKey === formUpload.upload.uploadKey);
        if (foundIndex === -1) {
            items.push(formUpload);
        }
        else {
            items[foundIndex] = formUpload;
        }

        form["reviewUploads"] = items;

        this.updatePostData(form, true);
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "ArticleInfoReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId,
                DocumentsConfig: this.getDocumentsConfig()
            }
        });

        ReportManager.execute(rq);
    };

    isEnabled(data){
        return !data.isReviewFinished;
    }

    isValidated(data){
        return data.isSubmitted;
    }

    ready = () => {
        // If currentStep is disabled (fastTrack), then go to tab "Cert."
        const currentStepIndex = this.props.setupProps.tabs.findIndex(tab => tab.key === "articles");
        if (this.props.setupProps.tabs[currentStepIndex].disabled)
            this.props.handleTabSelect("businessCertification");

        this.focusControl && this.focusControl.focus();
    }

    handleSave() {
        const me = this;

        this.beforeSave(() => {
            me.save();
        });
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'ART'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    getDocumentsConfig = () => {
        //Default: Corporations documents
        let documentsConfig = UploadsConfig[0];
        if (this.state.form.businessOwnershipId !== null && this.state.form.businessOwnershipId !== undefined )
            documentsConfig = UploadsConfig[this.state.form.businessOwnershipId-1];
        
        return documentsConfig;
    }

    renderUploadFields = () => {
        var me = this;
        
        return this.state.form.reviewUploads.map((item, index) => (
            me.renderUploadField(item, me.getDocumentsConfig())
        ));
    }

    renderUploadField = (reviewUpload, documentsConfig) => {
        const uploadKey = reviewUpload.upload.uploadKey;

        if (documentsConfig[uploadKey].visible)
            return (
                <ReviewUpload
                    key={uploadKey}
                    reviewUpload={reviewUpload}
                    reviewDisabled={this.state.form.isRenewal}
                    config={documentsConfig}
                    onChange={this.handleReviewUpload}
                    queueTypeCode={this.state.form.certificationQueueTypeCode}
                    tip={this.setTip(documentsConfig[uploadKey].tooltipCode)}/>
            );
    }

    renderForm() {
        var me = this;
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{marginTop:"0px", position: "relative"}}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{marginTop:"0px"}}>
                                    Corporate Documents – <small> Please submit all required Corporate Documents as listed below</small>
                                    {this.renderAdminStepToolbar()}
                                    {this.state.form.allowPrinting && <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>}
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                {me.renderUploadFields()}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {
                    this.state.form.showReview ?
                        <React.Fragment>
                            <Row>
                                <CommentsGrid
                                    ref={(c) => { this._commentsGrid = c }}
                                    comments={this.state.form.comments}
                                    documents={this.state.form.reviewDocuments}
                                    certificationKey={this.props.selectedId}
                                    reviewTypeCode={"ART"}
                                    queueTypeCode={this.state.form.certificationQueueTypeCode}
                                    enableExport={true}
                                    entityId={this.state.form.savedEntityId}
                                    readonly={!this.state.privileges.edit || !this.state.enabled}
                                    onSave={this.handleCommentsGrid}
                                    onCommentChange={this.handleCommentChange} />
                            </Row>
                            {this.state.form.showComplete ?
                                <Row>
                                    <ReviewPanel stepName="Articles"
                                        canComplete={(
                                            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                        ) ||
                                            this.state.form.reviewUploads.every((reviewUpload) => { return (me.getDocumentsConfig() && me.getDocumentsConfig()[reviewUpload.upload.uploadKey] && me.getDocumentsConfig()[reviewUpload.upload.uploadKey].visible) ? reviewUpload.validDocument : true; })}
                                        onChange={this.handleReviewStatus}
                                        reviewStatus={this.state.form.reviewStatus} />
                                </Row>
                                : null}
                        </React.Fragment> 
                        : null}
            </React.Fragment >
        )
    }
}

export default Articles;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/articles/Articles.js